<template>
  <div>
    <h1>Recent Email</h1>
    <div>
      <loading-spinner v-if="historyLoading"/>
      <div v-else-if="emailHistory" class="overflow-auto">
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Date</th>
            <th>Email</th>
            <th>Subject</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="message in emailHistory" :key="message.id">

            <td class="small">{{ new Date(message.ArrivedAt).toLocaleDateString('en-US', {}) }}</td>
            <td class="small"><strong>{{ message.ContactAlt }}</strong></td>
            <td class="small">{{ message.Subject }}</td>
            <td class="text-end"><span class="badge" :class="statusColor(message.Status)">{{ message.Status }}</span></td>

          </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="alert-info">
        No recent emails sent with MailJet
      </div>
    </div>
  </div>
</template>
<script setup>

import {onMounted, ref} from 'vue'
const emailHistory = ref()
const historyLoading = ref(false)
import { useStore } from 'vuex'
import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";
const store = useStore()

function statusColor (status) {
  switch (status.toLowerCase()) {
    case 'click':
    case 'clicked':
      return 'bg-success'
    case 'open':
    case 'opened':
      return 'bg-info'
    default:
      return 'bg-dark'
  }
}

async function fetchEmailHistory() {
  historyLoading.value = true
  emailHistory.value = null
  const response = await store.state.api.get('/admin/email/email-history')
  emailHistory.value = response.data?.history
  historyLoading.value = false
}

onMounted(async () => {
  await fetchEmailHistory()
})

</script>